import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import { AppColorViewModel } from "client/Api/Apps/common";
import { environmentHttpClient } from "client/Api/httpClient";
import { UserRequestKind, UserRequestStatus } from "./userRequest";

export type UserRequestUserClientModel = {
	id: number;
	name: string;
	email: string | null;
};

type AppUserRequestItemClientModel = {
	kind: UserRequestKind.AppAccess;
	id: number;
	name: string;
	icon: AppImageDisplayInfo;
	color: AppColorViewModel;
};

export type UserRequestItemClientModel =
	| AppUserRequestItemClientModel;

export type UserRequestClientModel = {
	id: number;
	requester: UserRequestUserClientModel;
	createdOn: string;
	item: UserRequestItemClientModel;
	status: UserRequestStatus;
	respondedOn: string | null;
	responder: UserRequestUserClientModel | null;
};

export type UserRequestDetailsClientModel = {
	id: number;
	requester: UserRequestUserClientModel;
	createdOn: string;
	item: UserRequestItemClientModel;
	reasonForRequest: string;
} & (
		{
			status: UserRequestStatus.Open;
		}
		|
		{
			status: UserRequestStatus.Accepted | UserRequestStatus.Declined;
			respondedOn: string;
			responder: UserRequestUserClientModel | null;
			responseNote: string | null;
		}
	);

export const enum UserRequestRespondKind {
	Accept = 1,
	Decline = 2
}

type BlockedRespondPreparationClientModel = {
	isBlocked: true;
	blockedItems: readonly UserRequestClientModel[];
};

type NoneBlockedRespondPreparationClientModel = {
	isBlocked: false;
	requesterNames: readonly string[];
};

export type RespondPreparationClientModel = BlockedRespondPreparationClientModel | NoneBlockedRespondPreparationClientModel;

export type RespondToUserRequestModel = {
	ids: readonly number[];
	kind: UserRequestRespondKind;
	note: string | undefined;
};

export type UserRequestRespondedClientModel = {
	id: number;
	status: UserRequestStatus;
	respondedOn: string;
	responder: UserRequestUserClientModel;
};

export function listAllUserRequests(
	signal?: AbortSignal
): Promise<readonly UserRequestClientModel[]> {
	return environmentHttpClient.get<readonly UserRequestClientModel[] > (
		"/UiApi/UserRequests/Manage/List",
		null,
		{ signal }
	);
}

export function deleteUserRequest(ids: readonly number[]): Promise<void> {
	return environmentHttpClient.delete<void> (
		"/UiApi/UserRequests/Manage/Delete",
		ids
	);
};

export function getUserRequest(
	id: number,
	signal?: AbortSignal
): Promise<UserRequestDetailsClientModel> {
	return environmentHttpClient.get<UserRequestDetailsClientModel> (
		`/UiApi/UserRequests/Manage/${id}`,
		null,
		{ signal }
	);
};

export function getRespondPreparation(
	ids: readonly number[],
	kind: UserRequestRespondKind,
	signal?: AbortSignal
): Promise<RespondPreparationClientModel> {
	return environmentHttpClient.get<RespondPreparationClientModel> (
		`/UiApi/UserRequests/Manage/RespondPreparation`,
		{ ids, kind },
		{ signal }
	);
}

export function respondToUserRequests(
	model: RespondToUserRequestModel
): Promise<readonly UserRequestRespondedClientModel[]> {
	return environmentHttpClient.put<readonly UserRequestRespondedClientModel[]> (
		`/UiApi/UserRequests/Manage/Respond`,
		model
	);
}
